import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

interface iReview {
  questionsAttempted: number;
  onReviewEnd: () => void;
}

export const Review = ({ questionsAttempted, onReviewEnd }: iReview) => {
  return (
    <>
      <Card className="bg-card-adaptive mt-10">
        <CardHeader>
          <CardTitle className="text-title-adaptive">Quiz Review</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <p className="text-body-adaptive text-lg">
            Questions attempted: {questionsAttempted}
          </p>
        </CardContent>
      </Card>

      <div className="flex justify-end">
        <Button className="mt-5" onClick={onReviewEnd}>
          Back to home
        </Button>
      </div>
    </>
  );
};
